<section class="login-registration-page">
  <form *ngIf="form" class="login-registration-form" [formGroup]="form" (ngSubmit)="acceptSignupInvitation()">
    <div class="main-form-title" data-test-id="form-title" [textContent]="getFormTitle"></div>
    <div class="mb-3" data-test-id="wrap-form-alias">
      <label class="form-label" for="alias"> {{ 'SIGN_UP_FORM_ALIAS_LABEL' | translate }} * </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('alias') }"
        type="text"
        formControlName="alias"
        id="alias"
        data-test-id="form-alias"
        placeholder="{{ 'SIGN_UP_FORM_ALIAS_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="error-description">
        {{ getErrorDescriptionId('alias') | translate }}
      </small>
    </div>
    <div class="password-group" data-test-id="wrap-accept-signup-invitation-password">
      <app-eye-password
        [form]="form"
        [id]="'password'"
        [controlName]="'password'"
        [dataTestId]="'accept-signup-invitation-password'"
        [showValidMark]="true"
        [errorTexting]="texting('form-password-error', 'FIELD_PASSWORD_ERROR')"
        [validTexting]="texting('form-valid-password', 'VALID_LOOKS_GOOD')"
        [instructionTexting]="texting('password-instruction', 'FORM_PASSWORD_INPUT_INSTRUCTION')"
        [placeholder]="'FORM_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_PASSWORD_LABEL'"
        [invalid]="isFieldInvalid('password')"
        [formValid]="isFieldValid('password')"
      ></app-eye-password>
    </div>
    <div class="password-group" data-test-id="wrap-repeat-password">
      <app-eye-password
        [form]="form"
        [id]="'repeat-password'"
        [controlName]="'repeatPassword'"
        [dataTestId]="'repeat-password'"
        [showValidMark]="true"
        [validTexting]="texting('change-password-form-valid-new-password', 'VALID_LOOKS_GOOD')"
        [errorTexting]="texting('form-repeat-password-error', repeatPasswordTextError)"
        [placeholder]="'FORM_REPEAT_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_REPEAT_PASSWORD_LABEL'"
        [invalid]="isRepeatPasswordFieldInvalid()"
        [formValid]="isRepeatPasswordFieldValid()"
      ></app-eye-password>
    </div>
    <div class="form-check" data-test-id="wrap-checkbox-form-agree-check">
      <input
        class="form-check-input"
        [ngClass]="{ 'is-invalid': isFieldInvalid('agreeCheck') }"
        type="checkbox"
        formControlName="agreeCheck"
        id="agreeCheck"
        data-test-id="form-agree-check"
      />
      <label class="form-label" for="agreeCheck" data-test-id="agree-check-label">
        <span
          [innerHtml]="'SIGN_UP_FORM_AGREE_CHECK' | translate: { privacyPolicyLink: '/terms' }"
          data-test-id="form-agree-check-links"
        ></span
        ><span>*</span>
      </label>
    </div>
    <div class="mb-2">
      <small class="form-text text-muted"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
    </div>
    <button
      appLongOperation
      appDebounceClick
      (debounceClick)="acceptSignupInvitation()"
      [debounceTime]="DEBOUNCE_TIME"
      class="btn btn-primary text-white"
      type="submit"
      data-test-id="form-signup-btn"
    >
      {{ 'SIGN_UP_FORM_SUBMIT_BTN' | translate }}
    </button>
  </form>
</section>
